import { colors } from 'theme/colors';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const StyledLicenceWrapper = styled(Grid)`
  display: flex;
  background-color: ${colors.gray100};
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 16px;
  column-spacing: 20px;
  row-gap: 16px;
`;
